export const GET_PLANTS_STATUS = "GET_PLANTS_STATUS"
export const GET_PLANTS_PRODUCTION = "GET_PLANTS_PRODUCTION"
export const GET_PRODUCTION_SUMMARY = "GET_PRODUCTION_SUMMARY"
